// Imports
import React from 'react';
import styled, { ThemeProvider } from 'styled-components/macro';
import { Props as CardProps } from '.';
import Input from '../../../../../foundation/front-end/components/forms/fields/input';
import ControlGroup from '../../../../../foundation/front-end/components/forms/control-group';
import FieldContainer from '../../../../../foundation/front-end/components/forms/field-container';
import FieldErrorMessage from '../../../../../foundation/front-end/components/forms/field-error-message';
import InputContainer from '../../../../../foundation/front-end/components/forms/input-container';
import { Label } from '../../../../../foundation/front-end/components/forms/labels';


// Styled components
const CardInputContainer = styled.div`
	height: 2.25em;
`;


// Define the accepted props
interface CompleteProps extends React.PropsWithChildren<CardProps> {
	uniqueID: React.MutableRefObject<string>;
	nameOnCardGetter?: React.MutableRefObject<(() => string) | undefined>;
	stripeError?: string;
	isLoading?: boolean;
}


// Function component
const CardContainer: React.FC<CompleteProps> = ({
	uniqueID,
	label,
	note,
	nameOnCardGetter,
	errorMessage,
	stripeError,
	isLoading,
	disabled,
	children,
}) => {
	// Create theme
	const theme = {
		hasError: Boolean(errorMessage || stripeError),
	};
	
	
	// Return JSX
	return (
		<ThemeProvider theme={theme}>
			<FieldContainer>
				{label && (
					<Label htmlFor={uniqueID.current}>
						{label}
						{note && <small>{note}</small>}
					</Label>
				)}
				
				<ControlGroup>
					<InputContainer>
						<CardInputContainer>{children}</CardInputContainer>
					</InputContainer>
				</ControlGroup>
				
				{(errorMessage || stripeError) && <FieldErrorMessage message={errorMessage || stripeError || ''} />}
			</FieldContainer>
			
			<Input
				type='text'
				name='nameOnCard'
				label='Name on card'
				placeholder={isLoading ? 'Loading…' : undefined}
				bindGetter={nameOnCardGetter ? (getter) => (nameOnCardGetter.current = getter) : undefined}
				required={!disabled}
				disabled={isLoading || disabled}
				exclude
			/>
		</ThemeProvider>
	);
};

export default CardContainer;
